// UID: NPO-FBO-MBR_NO
// @see https://sunstonecreditinc.atlassian.net/browse/SUNENG-2240
import { ApplicationFormValues } from '../../../../LoanDetailTypes';
import { Ruleset } from '../../interfaces/Ruleset';
import IsFBO from '../rules/IsFBO';
import { RulesetResult } from '../rules/';

class BorrowerReligiousMembersServedRuleset implements Ruleset {
  public evaluate = (data: Partial<ApplicationFormValues>): RulesetResult => {
    const isFbo = IsFBO.evaluate(data);
    return isFbo ? RulesetResult.REQUIRED : RulesetResult.HIDDEN;
  };
}

export default new BorrowerReligiousMembersServedRuleset();
